// @ts-nocheck
/* eslint-disable react/display-name */
/* eslint-disable react/no-multi-comp */
import _ from "lodash";
import React from "react";

import { connect } from "react-redux";

import { bindActionCreators } from "@reduxjs/toolkit";

import { alertActions } from "./Alert.slice";

import GroupItem from "./view/Alert.GroupItem.view";

const positions = [
  "top-center",
  "top-right",
  "top-left",
  "bottom-center",
  "bottom-left",
  "bottom-right"
];

type ComponentPropTypes = {
  alerts: Object[];
  actions: Object & alertActions.ActionsPropTypes;
}

const Alerts = ({ alerts, actions }: ComponentPropTypes) => {

  const {
    hide: handleHide,
    confirm: handleConfirm,
    cancel: handleCancel
  } = actions;

  const alertsGrouped = _.groupBy(alerts, "position");


  return (
    <div id="ui-alert">
      {
        _.map(positions, (position) =>
          <GroupItem
            handleHide={handleHide}
            handleConfirm={handleConfirm}
            handleCancel={handleCancel}
            key={position}
            alerts={alertsGrouped[position]}
            position={position} />
        )
      }
    </div>
  );


};

const mapStateToProps = (state) => {
  return {
    alerts: state.alerts
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(alertActions, dispatch),
  dispatch
});

const withState = connect(mapStateToProps, mapDispatchToProps);

export default withState(Alerts);
